import React from 'react';
import { Box, Chip, Avatar, IconButton, Typography } from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DescriptionIcon from '@mui/icons-material/Description';
import ImageIcon from '@mui/icons-material/Image';

// Function to dynamically get the icon based on file type
const getFileIcon = (fileType) => {
  if (fileType.includes('pdf')) {
    return <PictureAsPdfIcon />;
  } else if (fileType.includes('image')) {
    return <ImageIcon />;
  } else {
    return <DescriptionIcon />; // Default for other file types
  }
};

const FileChip = ({ file, handleRemoveFile }) => {
  return (
    file && (
      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
        <Chip
          avatar={
            <Avatar sx={{ bgcolor: 'transparent', borderRadius: '2px' }}>
              {getFileIcon(file.type)}
            </Avatar>
          }
          label={`${file.name} (${(file.size / 1024 / 1024).toFixed(2)} MB)`}
          variant="outlined"
          sx={{ flexGrow: 1, borderRadius: 1, borderColor:'dodgerBlue' }}
        />
        <IconButton onClick={handleRemoveFile} sx={{ marginLeft: '10px' }}>
          <DeleteIcon />
        </IconButton>
      </Box>
    )
  );
};

export default FileChip;
